var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTestimonialEmpty(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "99px",
    height: "73px",
    viewBox: "0 0 99 73",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icTestimonialEmpty") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Community-Testimonials-empty-state",
    transform: "translate(-508.000000, -503.000000)",
    fill: "#666666"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-35",
    transform: "translate(118.000000, 227.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(303.000000, 276.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.494577,11.4013015 C172.615265,17.7353896 166.175705,25.1778314 166.175705,33.7288503 C171.665248,34.3622591 176.20461,36.6055483 179.793926,40.4587852 C183.383243,44.3120222 185.177874,48.7722089 185.177874,53.8394794 C185.177874,59.2234543 183.436026,63.7628159 179.952278,67.4577007 C176.468529,71.1525854 172.087517,73 166.809111,73 C160.897295,73 155.777317,70.598361 151.449024,65.7950108 C147.12073,60.9916607 144.956616,55.1591088 144.956616,48.29718 C144.956616,27.7113938 156.46337,11.6124948 179.477223,0 L185.494577,11.4013015 Z M127.537961,11.4013015 C114.55308,17.7353896 108.060738,25.1778314 108.060738,33.7288503 C113.655849,34.3622591 118.247994,36.6055483 121.83731,40.4587852 C125.426627,44.3120222 127.221258,48.7722089 127.221258,53.8394794 C127.221258,59.2234543 125.453018,63.7628159 121.916486,67.4577007 C118.379953,71.1525854 113.97255,73 108.694143,73 C102.782328,73 97.6887416,70.598361 93.4132321,65.7950108 C89.1377227,60.9916607 87,55.1591088 87,48.29718 C87,27.7113938 98.4539708,11.6124948 121.362256,0 L127.537961,11.4013015 Z",
    id: "icTestimonialEmpty"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTestimonialEmpty);
export default __webpack_public_path__ + "static/media/icTestimonialEmpty.bbc3c8d67321c21ce4a6a14fca086504.svg";
export { ForwardRef as ReactComponent };